import { z } from "zod";

import { compose } from "@/common/helpers";
import { extractTranslations } from "@/services/cms";

export const getTermsAndConditionsResponseSchema = z
  .object({
    data: z.preprocess(
      compose(extractTranslations),
      z.object({
        translations: z.object({
          heading: z.string().min(3),
          content: z.string().min(3),
          footerText: z.string().min(3),
          footerDownloadText: z.string().min(3),
          footerDownloadUrl: z.string().min(3),
          headerText: z.string().min(3).optional(),
          updateDate: z.string().min(3).optional(),
          pdfUrl: z.string().min(3).optional(),
        }),
      }),
    ),
  })
  .transform(({ data }) => ({ ...data }));
